import {
  breadcrumb_item_styles_default
} from "./chunk.FLTQRQBR.js";
import {
  HasSlotController
} from "./chunk.TQTLXOET.js";
import {
  o
} from "./chunk.ONXLNBOP.js";
import {
  l
} from "./chunk.Z4OOI5NQ.js";
import {
  e,
  n
} from "./chunk.5E26GMTR.js";
import {
  $,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.YRXCXHD7.js
var SlBreadcrumbItem = class extends s4 {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "prefix", "suffix");
    this.rel = "noreferrer noopener";
  }
  render() {
    const isLink = this.href ? true : false;
    return $`<div part="base" class=${o({
      "breadcrumb-item": true,
      "breadcrumb-item--has-prefix": this.hasSlotController.test("prefix"),
      "breadcrumb-item--has-suffix": this.hasSlotController.test("suffix")
    })} ><span part="prefix" class="breadcrumb-item__prefix"><slot name="prefix"></slot></span>${isLink ? $`<a part="label" class="breadcrumb-item__label breadcrumb-item__label--link" href="${this.href}" target="${l(this.target ? this.target : void 0)}" rel=${l(this.target ? this.rel : void 0)} ><slot></slot></a>` : $`<button part="label" type="button" class="breadcrumb-item__label breadcrumb-item__label--button"><slot></slot></button>`}<span part="suffix" class="breadcrumb-item__suffix"><slot name="suffix"></slot></span><span part="separator" class="breadcrumb-item__separator" aria-hidden="true"><slot name="separator"></slot></span></div>`;
  }
};
SlBreadcrumbItem.styles = breadcrumb_item_styles_default;
__decorateClass([
  e()
], SlBreadcrumbItem.prototype, "href", 2);
__decorateClass([
  e()
], SlBreadcrumbItem.prototype, "target", 2);
__decorateClass([
  e()
], SlBreadcrumbItem.prototype, "rel", 2);
SlBreadcrumbItem = __decorateClass([
  n("sl-breadcrumb-item")
], SlBreadcrumbItem);

export {
  SlBreadcrumbItem
};
